module.exports = __webpack_public_path__ + "static/media/lu.e2fc15cc.svg";